import React from 'react';
import './BulkActions.css';

interface BulkActionsProps {
  selectedCount: number;
  onBulkApprove: () => void;
  onBulkReject: () => void;
  onAssignReviewer: () => void;
}

const BulkActions: React.FC<BulkActionsProps> = ({
  selectedCount,
  onBulkApprove,
  onBulkReject,
  onAssignReviewer,
}) => {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="bulk-actions">
      <div className="bulk-actions-info">
        {selectedCount} document{selectedCount !== 1 ? 's' : ''} selected
      </div>
      <div className="bulk-actions-buttons">
        <button className="bulk-action-btn bulk-approve-btn" onClick={onBulkApprove}>
          <span>✓</span> Bulk Approve
        </button>
        <button className="bulk-action-btn bulk-reject-btn" onClick={onBulkReject}>
          <span>×</span> Bulk Reject
        </button>
        <button className="bulk-action-btn bulk-assign-btn" onClick={onAssignReviewer}>
          <span>👤</span> Assign Reviewer
        </button>
      </div>
    </div>
  );
};

export default BulkActions;

